var _rect, _rect2, _path, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgConnexionIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 70,
    height: 70,
    viewBox: "0 0 70 70",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 70,
    height: 70,
    rx: 35,
    fill: "url(#paint0_linear_110_30)",
    fillOpacity: 0.5
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 2.5,
    y: 2.5,
    width: 65,
    height: 65,
    rx: 32.5,
    stroke: "url(#paint1_linear_110_30)",
    strokeWidth: 5
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.9762 52.7143C19.9762 52.7143 17 52.7143 17 49.7381C17 46.7619 19.9762 37.8333 34.8571 37.8333C49.7381 37.8333 52.7143 46.7619 52.7143 49.7381C52.7143 52.7143 49.7381 52.7143 49.7381 52.7143H19.9762ZM34.8571 34.8571C37.2251 34.8571 39.4962 33.9165 41.1706 32.242C42.845 30.5676 43.7857 28.2966 43.7857 25.9286C43.7857 23.5606 42.845 21.2896 41.1706 19.6151C39.4962 17.9407 37.2251 17 34.8571 17C32.4891 17 30.2181 17.9407 28.5437 19.6151C26.8693 21.2896 25.9286 23.5606 25.9286 25.9286C25.9286 28.2966 26.8693 30.5676 28.5437 32.242C30.2181 33.9165 32.4891 34.8571 34.8571 34.8571V34.8571Z",
    fill: "#F8F8F8"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_110_30",
    x1: -29.2857,
    y1: 70,
    x2: 123.214,
    y2: 70,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0A90C9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D90368"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_110_30",
    x1: -29.2857,
    y1: 70,
    x2: 123.214,
    y2: 70,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0A90C9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D90368"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgConnexionIcon);
export default __webpack_public_path__ + "static/media/ConnexionIcon.ecff1365e6409b5434ba3547b7589541.svg";
export { ForwardRef as ReactComponent };